// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment_container__xx1h2 {
  padding: 2rem;
  /* max-width: 1000px; */
  /* margin: 0 auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.payment_heading__rMjk1 {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #111827;
}

.payment_tableWrapper__rj\\+z7 {
  overflow-x: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.payment_table__IeKj0 {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.payment_table__IeKj0 th,
.payment_table__IeKj0 td {
  border-bottom: 1px solid #e5e7eb;
  padding: 0.9rem 1rem;
  text-align: left;
}

.payment_table__IeKj0 th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
}

.payment_table__IeKj0 tr:hover {
  background-color: #f3f4f6;
  transition: background 0.2s ease;
}

.payment_mono__xVEeH {
  font-family: "Courier New", monospace;
  font-size: 0.85rem;
  color: #555;
  word-break: break-all;
}

/* Status Badges */
.payment_statusBadge__sTqQp {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  font-weight: 500;
  font-size: 0.85rem;
}

.payment_paid__nLONa {
  background-color: #dcfce7;
  color: #166534;
}

.payment_pending__C9HiS {
  background-color: #fef9c3;
  color: #92400e;
}

/* Loading & Error */
.payment_loading__AYOEb,
.payment_error__IOAqn {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: #6b7280;
}

/* 📱 Responsive Mobile View */
@media (max-width: 768px) {
  .payment_table__IeKj0 th:nth-child(3),
  .payment_table__IeKj0 td:nth-child(3),
  .payment_table__IeKj0 th:nth-child(4),
  .payment_table__IeKj0 td:nth-child(4),
  .payment_table__IeKj0 th:nth-child(5),
  .payment_table__IeKj0 td:nth-child(5) {
    display: none; /* Hide less important columns */
  }

  .payment_heading__rMjk1 {
    font-size: 1.4rem;
    text-align: center;
  }

  .payment_container__xx1h2 {
    padding: 1rem;
  }

  .payment_table__IeKj0 th,
  .payment_table__IeKj0 td {
    padding: 0.75rem;
  }

  .payment_tableWrapper__rj\\+z7 {
    border-radius: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/payment.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE;;;;;;IAME,aAAa,EAAE,gCAAgC;EACjD;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".container {\n  padding: 2rem;\n  /* max-width: 1000px; */\n  /* margin: 0 auto; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.heading {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: #111827;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.table th,\n.table td {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0.9rem 1rem;\n  text-align: left;\n}\n\n.table th {\n  background-color: #f9fafb;\n  font-weight: 600;\n  color: #374151;\n}\n\n.table tr:hover {\n  background-color: #f3f4f6;\n  transition: background 0.2s ease;\n}\n\n.mono {\n  font-family: \"Courier New\", monospace;\n  font-size: 0.85rem;\n  color: #555;\n  word-break: break-all;\n}\n\n/* Status Badges */\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.6rem;\n  border-radius: 9999px;\n  font-weight: 500;\n  font-size: 0.85rem;\n}\n\n.paid {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.pending {\n  background-color: #fef9c3;\n  color: #92400e;\n}\n\n/* Loading & Error */\n.loading,\n.error {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n/* 📱 Responsive Mobile View */\n@media (max-width: 768px) {\n  .table th:nth-child(3),\n  .table td:nth-child(3),\n  .table th:nth-child(4),\n  .table td:nth-child(4),\n  .table th:nth-child(5),\n  .table td:nth-child(5) {\n    display: none; /* Hide less important columns */\n  }\n\n  .heading {\n    font-size: 1.4rem;\n    text-align: center;\n  }\n\n  .container {\n    padding: 1rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem;\n  }\n\n  .tableWrapper {\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `payment_container__xx1h2`,
	"heading": `payment_heading__rMjk1`,
	"tableWrapper": `payment_tableWrapper__rj+z7`,
	"table": `payment_table__IeKj0`,
	"mono": `payment_mono__xVEeH`,
	"statusBadge": `payment_statusBadge__sTqQp`,
	"paid": `payment_paid__nLONa`,
	"pending": `payment_pending__C9HiS`,
	"loading": `payment_loading__AYOEb`,
	"error": `payment_error__IOAqn`
};
export default ___CSS_LOADER_EXPORT___;
